import { object, mixed, string } from "yup";
import { REQUIRED_MESSAGE } from "../constants/login";

export const ValidateIdentitySchema = object({
  curp: string().required(REQUIRED_MESSAGE),
  selfie: mixed().required(REQUIRED_MESSAGE),
});
